import {
  DatasetQueryFragment,
  useCreateDatasetQueryMutation,
  useUpdateDatasetQueryMutation,
} from '@warebee/frontend/data-access-api-graphql';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { cn } from '../common/utils';
import { Button } from '../components/actions/Button';
import { warehouseSelectedId } from '../store/warehouse.state';

export type DatasetQuerySaveButtonProps = {
  id?: string;
  getPatch: () => Partial<DatasetQueryFragment>;
};

const DatasetQuerySaveButton: React.FC<DatasetQuerySaveButtonProps> = props => {
  const { t } = useTranslation('app');
  const warehouseId = useRecoilValue(warehouseSelectedId);
  const [callCreate] = useCreateDatasetQueryMutation();
  const [callUpdate] = useUpdateDatasetQueryMutation();

  const [isChanged, setIsChanged] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  async function updateDatasetQuery() {
    setIsLoading(true);
    setError(null);
    try {
      const patch = props.getPatch();
      await callUpdate({
        variables: {
          input: {
            ...patch,
            datasetQueryId: props.id,
          },
        },
      });
    } catch (ex) {
      console.error(ex);
      setError('Error');
    } finally {
      setIsLoading(false);
    }
  }

  async function createDatasetQuery() {
    try {
      setIsLoading(true);
      setError(null);
      const patch = props.getPatch();
      const response = await callCreate({
        variables: {
          input: {
            warehouseId,
            ...patch,
            title: patch.title ?? 'My Query',
          },
        },
      });
    } catch (ex) {
      console.error(ex);
      setError('Error');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Button
      className={cn('flex-1 text-sm')}
      label={props.id ? t`Update` : t`Save`}
      buttonSize="xxs"
      buttonType="primary"
      onPress={props.id ? updateDatasetQuery : createDatasetQuery}
      isDisabled={isLoading}
      isLoading={isLoading}
    />
  );
};

export default DatasetQuerySaveButton;
